import { WebsocketData } from './types';

export const initialState: WebsocketData = {
  ws: null,
};
